import * as React from "react";
import "./tab.component.css";
import { useEffect, useMemo, useState } from "react";
import { MessageResponse } from "../../model/MessageResponse";
import {
  IconSearch,
  IconTrash,
  IconEdit,
  IconPlus,
  IconActivity,
  IconStatusChange,
  IconTimeDuration15,
  IconUserCode,
  IconCheck,
  IconHandStop,
} from "@tabler/icons-react";
import {
  MRT_ColumnFiltersState,
  MRT_SortingState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_ColumnDef,
  useMantineReactTable,
  MantineReactTable,
} from "mantine-react-table";
import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Group,
  Input,
  Select,
  SelectProps,
  Tooltip,
} from "@mantine/core";
import { _localization } from "../../config/location";

import { modals } from "@mantine/modals";
import PartnersDeleteView from "./PartnersDeleteView";
import PartnersCreateView from "./PartnersCreateView";
import PartnersEditView from "./PartnersEditView";
import { DatePickerInput } from "@mantine/dates";
import { getUsersSelect } from "../../const/getSelectApi";
import { TblVendorModelQuery } from "../../model/TblVendorModelQuery";
import {  pageTable, repositorySign } from "../../_base/_const/_constVar";
import { useForm } from "@mantine/form";
import { ListVendorSearchModel } from "../../model/BaseSearchModel";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { SelectListItem } from "../../model/SelectListItem";

const PartnersTable = () => {
  const [data, setData] = useState<TblVendorModelQuery[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  // Table state
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  const [selectIds, setSelectIds] = useState<number[] | string[]>([]);
  const [openModal, setOpenModal] = useState(false);
  const [dataUpdated, setDataUpdated] = useState(false);

  const [dataListUser, setDataListUser] = useState<SelectListItem[]>([]);
  const _span = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };

  const [height, setHeight] = useState(0);
  const headerRef = React.useRef<HTMLDivElement>(null);

  const search: ListVendorSearchModel = {
    skip: 0,
    take: 0,
  };
  const form = useForm({
    mode: "uncontrolled",
    initialValues: search,
  });

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    let _softing = "";
    if (sorting && sorting.length > 0) {
      let _q = sorting[0];
      if (_q) _softing = _q.id;
    }
    try {
      const queryParams: ListVendorSearchModel = {
        skip: pagination.pageIndex * pagination.pageSize,
        take: pagination.pageSize,
        keySearch: form.getValues().keySearch,
        CreateBy: form.getValues().CreateBy,
        UpdateBy: form.getValues().UpdateBy,
        sort: _softing,
        isOrder: sorting.length > 0 ? sorting[0].desc : true,
      };

      const baseUrl = "/api/v1/TblVendor/get-list";
      const queryString = Object.entries(queryParams)
        .reduce((acc, [key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            const stringValue =
              value instanceof Date ? value.toISOString() : value.toString();
            return `${acc}&${key}=${encodeURIComponent(stringValue)}`;
          }
          return acc;
        }, "")
        .replace(/^&/, "");
      const url = `${baseUrl}${queryString ? `?${queryString}` : ""}`;
      const response = await repositorySign.get<
        MessageResponse<TblVendorModelQuery[]>
      >(url);

      if (response && response.success) {
        const dataList = response?.data;
        setData(dataList);
        setRowCount(response.totalCount);
        setDataUpdated(true);
        // await dataOrderTypeSelect();
        table.resetRowSelection();
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };
  useEffect(() => {
    fetchDataEmployee();
  }, []);
  const fetchDataEmployee = async () => {
    const dataApi = await getUsersSelect();

    if (dataApi && dataApi.length > 0) {
      const filteredData = dataApi.filter((item: any) => item.text !== null);
      setDataListUser(filteredData);
    }
  };

  const usersMap = useMemo(() => {
    const map = new Map<number, string>();
    dataListUser.forEach((user) => {
      map.set(Number(user.value), user.text);
    });
    return map;
  }, [dataListUser]);

  useEffect(() => {
    if (dataUpdated) {
      const updatedData = data.map((item) => ({
        ...item,
        createName: usersMap.get(item.createdBy) || "",
        lastUpdateName: usersMap.get(item.lastUpdatedBy) || "",
      }));
      setData(updatedData);
      setDataUpdated(false);
    }
  }, [data, dataUpdated, usersMap]);

  useEffect(() => {
    fetchData();
    fetchDataEmployee();
  }, [pagination.pageIndex, pagination.pageSize, sorting]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
  }, [rowSelection]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (170 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleDeletePartner = async (ids: number[]) => {
    modals.openConfirmModal({
      title: "",
      children: (
        <PartnersDeleteView
          ids={ids}
          onSearch={fetchData}
          onClose={setOpenModal}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleCreatePartner = async () => {
    modals.openConfirmModal({
      title: "Tạo mới đối tác",
      size: "auto",
      children: <PartnersCreateView onClose={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleUpdatePartner = async (id: number) => {
    modals.openConfirmModal({
      title: "",
      size: "auto",
      children: <PartnersEditView id={id} onClose={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleActivePartner = async ({ status }: { status: boolean }) => {
    try {
      let url = "/api/v1/TblVendor/update-active";
      const response = await repositorySign.post<MessageResponse<boolean>>(
        url,
        {
          ids: selectIds,
          status,
        }
      );

      if (response?.success) {
        await fetchData();
        NotificationExtension.Success(
          status
            ? "Kích hoạt đối tác thành công !"
            : "Ngừng kích hoạt đối tác thành công !"
        );
      } else {
        NotificationExtension.Fails(
          status
            ? "Kích hoạt đối tácn thất bại !"
            : "Ngừng kích hoạt đối tácn thất bại !"
        );
      }
    } catch (e) {
      console.log(e);
      return;
    }
  };

  function progessTemplate(props: any): any {
    return (
      <>
        <Tooltip label="Chỉnh sửa thông tin">
          <ActionIcon
            variant="light"
            aria-label="Settings"
            color="cyan"
            onClick={async () => {
              await handleUpdatePartner(props.vendorId);
            }}
          >
            <IconEdit size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label="Xóa">
          <ActionIcon
            variant="light"
            aria-label="Settings"
            color="red"
            onClick={async () => {
              await handleDeletePartner([props.vendorId]);
            }}
          >
            <IconTrash size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
      </>
    );
  }
  function getPropertiesVendorEnabledFlag(value: string) {
    switch (value) {
      case "Y":
        return {
          text: "Hoạt động",
          color: "green",
        };
      case "N":
        return {
          text: "Ngừng hoạt động",
          color: "red",
        };
      default:
        return {
          text: "Không xác định",
          color: "gray",
        };
    }
  }

  const columns = React.useMemo<MRT_ColumnDef<TblVendorModelQuery>[]>(
    () => [
      {
        accessorKey: "vendorId",
        header: "Id",
        visibleInShowHideMenu: false,
      },
      {
        accessorKey: "vendorName",
        header: "Tên đối tác",
      },
      {
        accessorKey: "phone",
        header: "Số điện thoại",
      },
      {
        accessorKey: "email",
        header: "Email",
      },
      {
        accessorKey: "vatRegistrationNum",
        header: "Mã số thuế",
      },
      {
        accessorKey: "enabledFlag",
        header: "Trạng thái",
        size: 50,
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Badge
              color={
                getPropertiesVendorEnabledFlag(
                  renderedCellValue?.toString() ?? ""
                ).color
              }
              variant="light"
              radius="sm"
            >
              <Flex>
                {
                  getPropertiesVendorEnabledFlag(
                    renderedCellValue?.toString() ?? ""
                  ).text
                }
              </Flex>
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "createName",
        header: "Người tạo",
      },
      {
        accessorKey: "lastUpdateDate",
        header: "Ngày cập nhật",
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 50,
        Cell: ({ renderedCellValue, row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            {progessTemplate(row.original)}
          </Box>
        ),
      },
    ],
    []
  );

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => <></>,
    renderToolbarInternalActions: ({ table }) => <></>,

    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.vendorId?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        //  left: ["mrt-row-select", "attachmentsCode"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    enableTopToolbar: false,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        fontWeight: "600", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: pageTable,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: true,
    },
  });

  return (
    <>
      <div
        style={{ border: "1px solid #dee2e6", padding: "5px" }}
        ref={headerRef}
      >
        <Flex justify={"end"}>
          <div>
            <Button
              leftSection={<IconPlus size={14} />}
              variant="outline"
              mr={"xs"}
              onClick={handleCreatePartner}
            >
              Thêm mới
            </Button>

            <Button
              leftSection={<IconTrash size={14} />}
              color="red"
              variant="outline"
              mr={"xs"}
              onClick={async () => {
                await handleDeletePartner(selectIds as number[]);
              }}
              disabled={selectIds.length < 1}
            >
              Xóa
            </Button>

            <Button
              leftSection={<IconActivity size={14} />}
              color="cyan"
              variant="outline"
              mr={"xs"}
              onClick={async () => {
                await handleActivePartner({ status: true });
              }}
              disabled={selectIds.length < 1}
            >
              Hoạt động
            </Button>

            <Button
              leftSection={<IconHandStop size={14} />}
              color="yellow"
              variant="outline"
              mr={"xs"}
              onClick={async () => {
                await handleActivePartner({ status: false });
              }}
              disabled={selectIds.length < 1}
            >
              Ngừng Hoạt động
            </Button>
          </div>
        </Flex>

        <form>
          <Grid>
            <Grid.Col span={_span}>
              {" "}
              <Input.Wrapper label="Từ khóa">
                <Input
                  leftSection={<IconSearch color="#15aabf" />}
                  placeholder="Nhập từ khóa"
                  key={form.key(`keySearch`)}
                  {...form.getInputProps("keySearch")}
                />{" "}
              </Input.Wrapper>
            </Grid.Col>

            <Grid.Col span={_span}>
              <Select
                label="Người tạo"
                placeholder="Chọn..."
                clearable
                searchable
                limit={50}
                comboboxProps={{
                  transitionProps: {
                    transition: "pop",
                    duration: 200,
                  },
                }}
                data={dataListUser.map((item) => {
                  return {
                    label: item.text ?? "",
                    value: String(item.value ?? ""),
                  };
                })}
                onClick={async () => {
                  if (!dataListUser || dataListUser.length < 1) {
                    await fetchDataEmployee();
                  }
                  return;
                }}
                nothingFoundMessage="Dữ liệu không có !"
                key={form.key(`CreateBy`)}
                {...form.getInputProps("CreateBy")}
              />
            </Grid.Col>
            <Grid.Col span={_span}>
              <Select
                label="Người cập nhật"
                placeholder="Chọn..."
                clearable
                searchable
                limit={50}
                comboboxProps={{
                  transitionProps: {
                    transition: "pop",
                    duration: 200,
                  },
                }}
                data={dataListUser.map((item) => {
                  return {
                    label: item.text ?? "",
                    value: String(item.value ?? ""),
                  };
                })}
                onClick={async () => {
                  if (!dataListUser || dataListUser.length < 1) {
                    await fetchDataEmployee();
                  }
                  return;
                }}
                nothingFoundMessage="Dữ liệu không có !"
                key={form.key(`UpdateBy`)}
                {...form.getInputProps("UpdateBy")}
              />
            </Grid.Col>
            <Grid.Col span={_span}>
              {" "}
              <Button
                mt={"25px"}
                leftSection={<IconSearch size={14} />}
                color="blue"
                variant="outline"
                onClick={async (e) => {
                  console.log(form.getValues());
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </form>
      </div>
      <div className="mt-5">
        <MantineReactTable table={table} />
      </div>
    </>
  );
};
export default PartnersTable;
